import Bluebird from 'bluebird';
import { apiCall } from './api';

export interface IUserConfig {
    useUTC: boolean;
    referenceIsRequired: boolean;
}

let cached: IUserConfig | null = null;

export default async function fetchUserConfig(): Bluebird<IUserConfig> {
    if (cached) {
        return cached;
    }

    const {
        data: {
            agent: {
                primary_time_zone_utc: useUTC,
                referenceIsRequired
            }
        }
    } = await apiCall<API.ConfigResponse>('GET', 'config');

    const result: IUserConfig = { useUTC, referenceIsRequired };
    cached = result;
    return result;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/services/user-config.ts